import React from 'react'
import {
    Row, Spinner, Col
} from 'reactstrap'
import ProductItem from '../../../components/productItem';
import '../productCategory.css'

function ProductCategoryComponent(props) {
    const { category, products } = props
    // const [categoria, setCategoria] = React.useState('')
    // const [productos, setProductos] = React.useState([])

    // if (categoria !== category)
    //     setCategoria(category)

    // React.useMemo(() => {
    //     const result = props.leerProductos(category)
    //     console.log('productos: ', result)
    //     setProductos(result)
    //     return result
    // }, [categoria])


    
    return (
        <React.Fragment>
            <Row>
                {
                    category ?
                        <Col><h2>{category.Descripcion}</h2></Col>
                        :
                        <div className="spinnerProductos"><Spinner type="grow" /></div>
                }
            </Row>
            <Row>
                {
                    products && products.map(product => <Col key={product.id} md={6}><ProductItem product={product} /></Col>)
                }
            </Row>
        </React.Fragment>
    )
}

export default ProductCategoryComponent